import { t } from "i18next";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import useMapStore from "@/store/mapStore";

function PoiDetailsRouteToggle() {
  const accessibleRoute = useMapStore((state) => state.accessibleRoute);
  const setAccessibleRoute = useMapStore((state) => state.setAccessibleRoute);

  const onValueChangeHandler = (checked: boolean) => {
    setAccessibleRoute({
      accessibleRoute: checked,
      forceAccessibleRoute: true,
    });
  };

  return (
    <>
      <div className="flex items-center justify-end space-x-2">
        <Label
          htmlFor="use-elevators"
          className="cursor-pointer group-data-[dir=rtl]:ml-2"
        >
          {t("use-elevators")}
        </Label>
        <Switch
          id="use-elevators"
          checked={accessibleRoute}
          onCheckedChange={onValueChangeHandler}
        />
      </div>
    </>
  );
}

export default PoiDetailsRouteToggle;
